import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
// Request Dependency
import { useMutation } from 'react-query';
import { forgotPasswordService } from 'services/auth';
// Toasting error Response
import UseToast from 'hooks/use-toast';
// Custom Components
import TextInput from '@core/components/textinput/TextInput';
import ActionButton from '@core/components/actionbutton/ActionButton';
import BackButton from '@core/components/backbutton/BackButton';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import classes from './ForgotPassword.module.scss';

const ForgotPassword = () => {
	const { toast, ToastContainer } = UseToast();
	const [status, setStatus] = useState(false);
	const { mutate: callForgotPasswordApi, isLoading } = useMutation(forgotPasswordService, {
		onSuccess: () => {
			setStatus(true);
		},
		onError: (error) => {
			toast(error.response?.data?.data, 'Alert');
		}
	});
	// setup UseForm
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm();

	const onSubmit = (value) => {
		callForgotPasswordApi(value);
	};

	const seoProps = generateSeoProps({
		title: 'Forgot Password: Recover Your Account & Courses - Pharmuni',
		description: 'Lost credentials? We’ll email you a secure link to restore course progress, download certificates and continue your pharmaceutical career path.',
		canonical: 'forgot-password'
	});

	return (
		<>
			<NextSeo {...seoProps} />
			<ToastContainer />
			<div
				className={`${classes['forgot-password-wrapper']} d-flex flex-column align-items-center `}>
				<div className={`${classes['forgot-password']}  d-flex flex-column align-items-stretch`}>
					<BackButton type="text" className="d-none d-md-flex my-4" />
					<h1>Forgot password</h1>
					{!status && (
						<>
							<p>
								If we find your email in our data, we’ll send you an email with reset password link
							</p>
							<form onSubmit={handleSubmit(onSubmit)}>
								<TextInput
									validation={{
										required: true,
										pattern: {
											value:
												/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											message: 'Please enter a correct email address'
										}
									}}
									input={{
										type: 'email',
										label: 'Email Address',
										name: 'email',
										placeholder: 'Email',
										id: 'email'
									}}
									errors={errors}
									register={register}
								/>
								<ActionButton type="submit" disabled={isLoading} loading={isLoading}>
									Send reset password link
								</ActionButton>
							</form>
						</>
					)}
					{status && (
						<p>
							You may receive an email shortly. Follow instructions in email to reset your password.
						</p>
					)}
				</div>
			</div>
		</>
	);
};

export default ForgotPassword;
